<template>
  <main class="mc-board container">
    <winners-modal></winners-modal>
    <quizzes-item-now>
    </quizzes-item-now>
    <div class="mc-board-row row">
      <div class="col">
        <studio-status-vertical></studio-status-vertical>
      </div>
      <div class="col">
        <chat-thread-lg class="chat-thread"></chat-thread-lg>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapState
  // mapGetters
} from 'vuex'
import StudioStatusVertical from '@/components/studio/StudioStatusVertical'
import ChatThreadLG from '@/components/chat/ChatThreadLG'
import WinnersModal from '@/components/studio/WinnersModal'
import QuizzesItemNow from '@/components/quizzes/QuizzesItemNow'
// import l from '@/vendor/logger'

export default {
  name: 'AssistBoard',

  created () {
    this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.commit('setRid', this.$route.params.rid)
    this.$store.dispatch('room/bindRoom')
    this.$store.dispatch('quizzes/bindQuizzes')
    this.$store.dispatch('quizzes/bindQuizOfToday')
    this.$store.dispatch('chat/bindChat')
    this.$store.dispatch('result/bindResult')
    this.$store.dispatch('chatOption/bindBannedWatchers')
    this.$store.dispatch('chatOption/bindFilteringWords')
    this.$store.commit('room/setRoomType', 'ASSIST_BOARD')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapState([
      'rid'
    ])
  },

  methods: {
    unbind () {
      this.$store.dispatch('chat/unbindChat')
      this.$store.dispatch('quizzes/unbindQuizzes')
      this.$store.dispatch('quizzes/unbindQuizOfToday')
      this.$store.dispatch('room/unbindRoom')
      this.$store.dispatch('result/unbindResult')
      this.$store.dispatch('chatOption/unbindBannedWatchers')
      this.$store.dispatch('chatOption/unbindFilteringWords')
    }
  },

  watch: {
  },

  components: {
    StudioStatusVertical,
    WinnersModal,
    QuizzesItemNow,
    'chat-thread-lg': ChatThreadLG
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mc-board {
  & .mc-board-row {
    & .chat-thread {
      height: 90vh;
    }
  }
}
</style>
